import React, { useEffect, useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import httpRequest from "../../utils/Http";

const WarehouseReverse = ({ selectedRows, setEditRow, setReload, closeForm, setReverseReload }) => {
  const [formData, setFormData] = useState({
    partner_id: selectedRows?.[0]?.booking_detail?.partner_id || "",
    state_id: selectedRows?.[0]?.booking_detail?.booking_state || "",
    parts: selectedRows || [],
    sc_id: selectedRows?.[0]?.sc_id || "",
    warehouse_id: null
  });

  const [warehouselist, setWarehouselist] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setSubmit] = useState(false);

  useEffect(() => {
    if (selectedRows?.length > 0) {
     // console.log(selectedRows)
      setFormData((prev) => ({
        ...prev,
        partner_id: selectedRows?.[0]?.booking_detail?.partner_id || "",
        state_id: selectedRows?.[0]?.booking_detail?.booking_state || "",
        parts: selectedRows || [],
        sc_id: selectedRows?.[0]?.sc_id || "",
      }));

      (async () => {
        const scdata = await httpRequest(
          `getpartnercentralwarehouse?partner_id=${formData.partner_id}&state_id=${formData.state_id}`,
          {},
          "GET"
        );

        if (scdata.status && scdata.data) {
          setWarehouselist(scdata.data);
        } else {
          setFormData((prev) => ({ ...prev, warehouse_id: null }));
          setWarehouselist([]);
        }
      })();
    }
  }, [selectedRows]);

  const validateForm = (values) => {
    const errors = {};
    if (!values.warehouse_id) {
      errors.warehouse_id = "Warehouse is required";
    }
    return errors;
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();
    const errors = validateForm(formData);
    setFormErrors(errors);
    setSubmit(true);
  };

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors).length === 0) {
      (async () => {
        const data = await httpRequest("generatedefectivechallan", formData, "POST");

        if (data.status) {
          toast.success(data.message);
          setReload(true);
          setReverseReload(true);
          setEditRow({});
          closeForm();
        } else {
          toast.error(data.message);
        }
        setSubmit(false);
      })();
    }
  }, [isSubmit, formErrors]);

  return (
    <div className="form-overlay">
      <div className="form-container" style={{ maxWidth: "500px" }}>
        <div className="form-content">
          <form id="assignPartner" onSubmit={onSubmitHandler}>
            <div className="row">
              <div className="col-lg-12">
                <div className="card" style={{ marginBottom: 0 }}>
                  <div className="card-header">
                    <h3 className="card-title">Select Warehouse for Reverse</h3>
                   <div className="card-tools">
                    <button
                        type="button"
                        className="btn btn-sm btn-dark"
                        onClick={closeForm}
                        style={{ float: "right" }}
                      >
                        X
                      </button>
                   </div>
                  </div>

                  <div className="card-body">
                    <div className="form-group">
                      <label>
                        Warehouse List *{" "}
                        <span className="text-danger">{formErrors.warehouse_id}</span>
                      </label>
                      <Select
                        name="warehouse_id"
                        placeholder="Select Warehouse"
                        value={
                          warehouselist.find(
                            (option) => option.value === formData.warehouse_id
                          ) || null
                        }
                        options={warehouselist}
                        onChange={(val) =>
                          setFormData((prev) => ({
                            ...prev,
                            warehouse_id: val.value
                          }))
                        }
                      />
                    </div>
                  </div>

                  <div className="card-footer text-center" style={{ backgroundColor: "#fff" }}>
                    <button
                      type="submit"
                      className="btn btn-primary col-md-12"
                      style={{ margin: 0 }}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default WarehouseReverse;
